module.exports = __webpack_public_path__ + "static/media/photo_3o3_1.3b924ea8.png";